import { FormBuilder, FormGroup, FormControl, FormArray } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';

export abstract class PlannerBaseDTO {
    public formGroup: FormGroup;
    public fields: PlannerDTOField[] = [];
    public cdr: ChangeDetectorRef;

    constructor(protected fb?: FormBuilder) { }

    protected init(): void {
        this.formGroup = this.fb.group({});

        for (const field of this.fields) {
            if (field.type === 'formArray' && field.arrayClass) {
                const formArray = new FormArray([]);
                this.formGroup.addControl(field.name, formArray);

                if (field.createInitialItem) {
                    const newItem = <PlannerBaseDTO>(
                        new field.arrayClass(this.fb)
                    );
                    formArray.push(newItem.formGroup);
                }
            } else if (
                field.type === 'formGroup' &&
                field.arrayClass &&
                field.createInitialItem
            ) {
                const newItem = <PlannerBaseDTO>(
                    new field.arrayClass(this.fb)
                );
                if (field.groupValidator) {
                    newItem.formGroup.setValidators(field.groupValidator);
                }
                this.formGroup.addControl(field.name, newItem.formGroup);
            } else {
                this.formGroup.addControl(
                    field.name,
                    new FormControl({ value: field.defaultValue, disabled: field.disabled }, field.validators)
                );
            }
        }
    }
}
